import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ONLWalletSessionResponse } from '../models/session.model';

declare var pendo: any;

@Injectable({
  providedIn: 'root'
})

export class ScriptService {
  
  constructor() {
  //  this.pendoInit();
   }


  //Call "pendo.validateInstall()" from the browser console if you want to test if pendo has been initialized. It should show the ID's specified below.
  //Right now we only initialize pendo if the user is logged in



    pendoInit(isPPI: boolean, pendoData:any, isBilliant: boolean = false
    //  { // <-- CORRECTED: Accepts isPPI and pendoData
      // objectUID: string | null;
      // displayName: string;
      // walletId: string;
      // walletRole: string;
      // productType: string;
      // billingType: string;
      // currentSessionId: string;
   // })
    ): void {

    // --- CRITICAL FIX: Skip Pendo for PPI users ---
    if (isPPI || isBilliant) {
      console.log('ScriptService: Pendo initialization SKIPPED for PPI/Billiant session.');
      return; // Exit the method immediately if it's a PPI/Billiant session
    }
    // --- End of critical fix ---

    // Only init Pendo in the UAT or Production environment.
    if (!environment.isUat && !environment.production) {
      console.log('ScriptService: Pendo initialization skipped for non-UAT/Production environment.');
      return;
    }

    // Ensure Pendo global object is available before attempting to initialize
    if (typeof pendo === 'undefined' || typeof pendo.initialize !== 'function') {
      console.warn('ScriptService: Pendo global object not found or not ready. Attempting to download Pendo script.');
      this.downloadPendo(); // Download Pendo script if not already present
      // After downloading, Pendo might not be immediately available.
      // A more robust solution might involve a delay or checking for pendo readiness.
      // For now, we proceed assuming it will be available shortly.
    }

    // Prepare visitor data safely using the passed pendoData
    const visitorData: any = {
      id: pendoData.objectUID || pendoData.walletId || 'anonymous', // Use objectUID if available, fallback to WalletID
      displayName: pendoData.displayName || 'Guest',
      currentSessionId: pendoData.currentSessionId,
    };

    // Ensure objectUID is a string or null
    if (pendoData.objectUID !== null && pendoData.objectUID !== undefined) {
      visitorData.objectUID = String(pendoData.objectUID);
    } else {
      visitorData.objectUID = null;
    }

    // Prepare account data safely
    const accountData: any = {
      id: pendoData.walletId,
      role: pendoData.walletRole,
      productType: pendoData.productType,
      billingType: pendoData.billingType,
    };

    if (typeof pendo !== 'undefined' && typeof pendo.initialize === 'function') {
      try {
        pendo.initialize({
          visitor: visitorData,
          account: accountData
        });
        console.log('ScriptService: Pendo initialized successfully for ONL session with visitor:', visitorData, 'account:', accountData);
      } catch (initError) {
        console.error('ScriptService: Pendo initialization failed during pendo.initialize call:', initError);
      }
    } else {
      console.warn('ScriptService: Pendo global object not available after download attempt. Initialization skipped.');
    }
  }


    //Just downloads the pendo script from the CDN.
    downloadPendo() {
      let p = window;
      let e = document;
      let n = 'script';
      let d = 'pendo';
      let o;
  
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
  
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w)(function (m) {
        o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
      })(v[w]);
  
      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/872f0080-bf61-42d7-5156-5f14cc1d189c/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    }

    // Beginning of Glia Script 

    loadGlia() {
      // let userInfo = JSON.parse(sessionStorage.getItem('userDetails'));
      this.unloadGlia();
      //if(document.querySelectorAll('script[data-script-identifier="glia"]')?.length == 0) {
        var gliaScript = document.createElement('script');
        /* if (!userInfo) {
          script.src = 'https://api.glia.com/salemove_integration.js';
          script.async = true;
        }
        else { */
  
        // }
        gliaScript.setAttribute('data-script-identifier', 'glia');
        gliaScript.text = this.generateGliaScript();
        document.head.appendChild(gliaScript);
      /* }
      else {
        gliaScript.text = this.generateGliaScript();
      } */
  
      /* else {
        if(userInfo) {
          this.unloadGlia();
          this.loadGlia();
        }
      } */
    }

    generateGliaScript() {
      return `var installGlia = function(a) {
              !function(a, b, c, d) {
                var e = a.createElement(b),
                f = a.getElementsByTagName(b)[0];
                e.async = 1;
                e.src = c;
                e.type = "text/javascript";
                e.setAttribute("data-script-identifier","glia");
                d && e.addEventListener("load", d);
                f.parentNode.insertBefore(e, f);
              } (document, "script", "https://api.glia.com/salemove_integration.js", a)
            };
            installGlia(function() {
              let userInfo = JSON.parse(sessionStorage.getItem('userDetails'));
              let policyInfo = JSON.parse(sessionStorage.getItem('policyDetails'));
              let businessName = userInfo?.insured ? userInfo.insured : userInfo?.policyHoldersName;
              sm.getApi({version: 'v1'}).then(function(glia) {
                glia.updateInformation({
                  phone: userInfo?.contactPhone,
                  email: userInfo?.emailAddress,
                  name: userInfo?.contactName,
                  externalId: userInfo?.policyNumber,
                  note: "",
                  customAttributes: {
                    zipCode: userInfo?.zipCode,
                    business: businessName,
                    country: policyInfo?.policyCountry_Ext
                  }
                }).then(function() {
                  //Callback fired after the Visitor Information has
                  //been successfully updated
                }).catch(function(error) {
                  //Callback fired when the request for updating the
                  //Visitor Information fails
                });
              });
            });`
    }
  
    unloadGlia() {
      document.querySelectorAll('script[data-script-identifier="glia"]')?.forEach(
        el => el.remove()
      );
    } 

    // End of Glia Script

}
